module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-5-aa2a5610.png";